
    <h3 mat-dialog-title [hidden]="publisherNote.id">Write a new note</h3>
    <h3 mat-dialog-title [hidden]="!publisherNote.id">Edit note</h3>
    <mat-dialog-content>
          <mat-form-field floatLabel="always" class="w-100">
              <textarea matInput name="notes" required [(ngModel)]="publisherNote.note" style="min-height: 150px "
                        placeholder="Note" class="textarea-note"></textarea>
          </mat-form-field>
    </mat-dialog-content>
    <cm-custom-upload-multiple-button class="d-block mb-4"
                                      [initialFilesList]="publisherNote.fileAttachments"
                                      [emitInitialFileChange]="true"
                                      (filesChange)="filesChange($event)"
                                      label="File upload">
    </cm-custom-upload-multiple-button>
    <mat-dialog-actions class="justify-content-center">
	    <button mat-raised-button [mat-dialog-close]="false">Close</button>
      <button mat-raised-button
              color="primary"
              class="mr-1"
              [disabled]="!publisherNote.note || !publisherNote.note.length"
              (click)="save()">Save</button>
    </mat-dialog-actions>
  